import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.b6v_1 = partyId;
        this.c6v_1 = pinId;
        this.d6v_1 = icon;
        this.e6v_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.b6v_1.toString() + ', pinId=' + this.c6v_1.toString() + ', icon=' + this.d6v_1 + ', name=' + this.e6v_1 + ')';
      }
      hashCode() {
        var result = this.b6v_1.hashCode();
        result = imul(result, 31) + this.c6v_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.b6v_1.equals(other.b6v_1))
          return false;
        if (!this.c6v_1.equals(other.c6v_1))
          return false;
        if (!(this.d6v_1 === other.d6v_1))
          return false;
        if (!(this.e6v_1 === other.e6v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
